import { render, staticRenderFns } from "./PatrolProduct.vue?vue&type=template&id=1ea412d5&scoped=true&"
import script from "./PatrolProduct.vue?vue&type=script&lang=js&"
export * from "./PatrolProduct.vue?vue&type=script&lang=js&"
import style0 from "./PatrolProduct.vue?vue&type=style&index=0&id=1ea412d5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea412d5",
  null
  
)

export default component.exports